import React from 'react';
import { ForgotPassword as SharedForgotPassword } from '@gastrosoft/shared/auth';
import { useBranding } from '../contexts/BrandingContext';
import { authClient } from './authClient';

export default function ForgotPassword() {
  const { logo, appName } = useBranding();
  return <SharedForgotPassword appTitle={appName} logo={logo} authClient={authClient} />;
}
